export enum DiscountType {
  Percentage = 1,
  Amount = 2,
}
